var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCliniciansManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.565 0.234559C8.49078 0.160203 8.40262 0.101213 8.30557 0.0609648C8.20852 0.0207167 8.10449 0 7.99943 0C7.89437 0 7.79034 0.0207167 7.69329 0.0609648C7.59625 0.101213 7.50809 0.160203 7.43386 0.234559L0.234218 7.43449C0.122376 7.54637 0.0462145 7.6889 0.015362 7.84406C-0.0154905 7.99922 0.000351143 8.16004 0.0608842 8.3062C0.121417 8.45236 0.223924 8.57729 0.355445 8.6652C0.486966 8.7531 0.641597 8.80004 0.79979 8.80007H1.59975V14.4C1.59975 15.2824 2.31731 16 3.19967 16H12.7992C13.6816 16 14.3991 15.2824 14.3991 14.4V8.80007H15.1991C15.3574 8.80042 15.5123 8.75371 15.6441 8.66587C15.7759 8.57803 15.8786 8.45301 15.9392 8.3067C15.9998 8.16038 16.0155 7.99936 15.9845 7.84407C15.9534 7.68877 15.8769 7.54622 15.7646 7.43449L8.565 0.234559ZM12.8 14.4H3.19967V6.73129L7.99943 1.93134L12.7992 6.73129V10.4001L12.8 14.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6H7.25V8.25H5V9.75H7.25V12H8.75V9.75H11V8.25H8.75V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCliniciansManagement);
export default __webpack_public_path__ + "static/media/ic-clinicians-management.1182d0fb.svg";
export { ForwardRef as ReactComponent };